import { forwardRef, type InputHTMLAttributes } from 'react'
import clsx from 'clsx'
import './Input.css'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={clsx('input', invalid && 'input-invalid', className)}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  )
})
